import get from 'lodash/get';

export default function isPayoutCardFormModified(formData, defaultState) {
  const details = get(formData, 'paymentOption.details');

  if (details) {
    return formData.expirationYear !== details.expirationYear
      || formData.expirationMonth !== details.expirationMonth
      || formData.zipCode !== details.postalCode;
  }

  return formData.cardNumber !== defaultState.cardNumber
    || formData.expirationYear !== defaultState.expirationYear
    || formData.expirationMonth !== defaultState.expirationMonth
    || formData.zipCode !== defaultState.zipCode;
}
